import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import {inject} from 'mobx-react';

const shopListItemClosedTag = {
    "margin": "auto",
    "letterSpacing": ".5pt",
    "fontSize": "1.25em",
    "fontFamily": "GraphikMedium"
};

@inject('RootStore')
export default class ShopListItemMaintenanceBox extends Component {

    render() {
        let shopListItemClosedBoxStyle = {
            "color": "white",
            "textAlign": "center",
            "borderRadius": "0 50% 50% 0",
            "height": "100%"
        };
        shopListItemClosedBoxStyle.backgroundColor = this.props.RootStore.styleStore.currentStylesDict.shopListEtaBoxClosedColor;
        return (
            <Flexbox flexGrow={1} style={shopListItemClosedBoxStyle}>
                <div style={shopListItemClosedTag}>Back<br/>Soon
                </div>
            </Flexbox>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_list_item/shop_list_item_maintenance_box.js